module.exports = __webpack_public_path__ + "static/media/video.f2975b95.mp4";